import {
  WithStyles,
  Theme,
  createStyles,
  CssBaseline,
  withStyles,
} from "@material-ui/core";
import * as React from "react";
import AppBarComponent from "./AppBarComponent";
import DrawerComponent from "./DrawerComponent";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  toolBarData: any;
  profileData: any;
  pageTitle: any;
  company?: any;
  companies?: any;
  onHelperClicked?: any;
}
class BaseComponent extends React.Component<Props> {
  state = {
    mobileOpen: false,
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: true });
  };
  componentDidMount = () => { };
  render() {
    const {
      classes,
      profileData,
      companies,
      pageTitle,
      toolBarData,
      company,
      onHelperClicked,
    } = this.props;
    return (
      <React.Fragment>
        <div className={classes.root}>
          <CssBaseline />
          <AppBarComponent
            toolBarData={toolBarData}
            pageTitle={pageTitle}
            showCompanies={true}
          />
          <DrawerComponent
            onHelperClicked={onHelperClicked}
            profileData={profileData}
            companies={companies}
            company={company}
          />
          <main className={classes.content}>
            <div className={classes.toolbar} />
            {this.props.children}
          </main>
        </div>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(BaseComponent);
